
























import { Component, Prop, Mixins } from "vue-property-decorator";
import InvoicePaymentModal from "@/components/app/global/payments/invoicePaymentModal.vue";
import {
  StoredCardData,
  PaymentMethodType
} from "@/models/selectPaymentMethod";

@Component
export default class InvoiceAutoPayModal extends Mixins(InvoicePaymentModal) {
  @Prop({ default: undefined })
  public amount!: number;

  @Prop({ default: undefined })
  public walletAmount!: number;

  // Data
  public processing = {};
  public isLoadingInvoice = true;

  public async created() {
    try {
      this.$set(this.processing, "payment", true);
      await Promise.all([this.waitMinimum(), this.pay()]);
    } finally {
      this.$delete(this.processing, "payment");
    }
  }

  public waitMinimum() {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(true);
      }, 2 * 1000);
    });
  }

  // Getters

  // Overwrite
  public async pay() {
    if (!this.preselectedStoredPaymentMethodId) {
      this.$delete(this.processing, "payment");
      this.$emit("close");
      return;
    }
    try {
      this.paymentMethod = {
        amount: this.amount || 0,
        walletAmount: this.walletAmount || 0,
        type: PaymentMethodType.STORED_CARD,
        data: {
          payment_details_id: this.preselectedStoredPaymentMethodId
        } as StoredCardData
      };
      await this.preparePaymentData(this.invoice.client_id);
      // Execute payment
      await this.executePayment();
      // Emit 'success'
      this.$emit("success", { invoiceId: this.invoice.id });
    } catch (error) {
      this.$emit("error", error);
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    } finally {
      this.$emit("close");
    }
  }
}
